import CourseHomeHeader from 'courses/components/course-home-header';

/* @ngInject */
export default function CourseHomeBaseController(
  $scope,
  CourseHomeManager,
  CurrentCourseManager,
  ReportsManager,
  TimelinesManager,
  nvCurrentPage,
  RailsRoutes,
  $state,
) {
  const vm = this;

  vm.manager = CourseHomeManager;
  vm.currentCourseManager = CurrentCourseManager;
  vm.reportsManager = ReportsManager;
  vm.TimelinesManager = TimelinesManager;
  vm.catalogId = CurrentCourseManager.course.catalogId;
  vm.nvCurrentPage = nvCurrentPage;
  vm.RailsRoutes = RailsRoutes;

  $scope.CourseHomeHeader = CourseHomeHeader;

  vm.getExtraTopNavContentClass = () => ({
    'no-padding': true,
  });

  vm.exitEditMode = () => {
    $state.go('course-home', { id: vm.currentCourseManager.course.catalogId });
  };
}
